export const dictionaryToSelect = (dictionary) => {
  return dictionary.map((item) => {
    const [[value, label]] = Object.entries(item);
    return { label, value };
  });
};
